import { render } from "./PagesIntro.vue?vue&type=template&id=ffbd6026"
import script from "./PagesIntro.vue?vue&type=script&lang=js"
export * from "./PagesIntro.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/origina/V3/v2026.14.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__